import { PasswordResetCtrl } from '../controllers/PasswordResetCtrl';
import { Module } from '../Module';

Module.instance().directive('tbPasswordReset',
  () => {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'passwordReset.html',
      scope: {
        username: '@',
        token: '@'
      },
      controller: PasswordResetCtrl
    };
  }
);
